"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconParcelOutline = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconParcelOutline = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M10.95 19.544v-6.888l-6.1-3.57v6.939l6.1 3.52Zm2.124 0 6.05-3.519V9.111l-6.05 3.52v6.913ZM12 22.648l-9.3-5.311V6.688L12 1.377l9.275 5.311v10.649L12 22.648ZM16.03 8.45l1.944-1.13L12 3.874l-1.925 1.111L16.03 8.45ZM12 10.789l1.874-1.097L7.9 6.223 6.024 7.319 12 10.79Z"
}));
exports.IconParcelOutline = IconParcelOutline;
//# sourceMappingURL=IconParcelOutline.js.map